import { useEffect, useRef, useState } from "react";
import "./Loading.css";

export default function Loading({
  active,
  text = "데이터를 불러오는 중입니다...",
  delayMs = 100,
  minShowMs = 250,
}) {
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(false);

  const showTimerRef = useRef(null);
  const hideTimerRef = useRef(null);
  const shownAtRef = useRef(0);

  useEffect(() => {
    // 켜질 때: delay 후 표시
    if (active) {
      clearTimeout(hideTimerRef.current);
      clearTimeout(showTimerRef.current);

      showTimerRef.current = setTimeout(() => {
        setMounted(true);
        setVisible(true);
        shownAtRef.current = Date.now();
      }, delayMs);

      return () => {
        clearTimeout(showTimerRef.current);
      };
    }

    // 꺼질 때
    clearTimeout(showTimerRef.current);

    // 아직 표시도 안 된 상태면 그냥 종료
    if (!visible) {
      setMounted(false);
      return;
    }

    // 표시된 적 있으면 최소 표시 시간 보장
    const elapsed = Date.now() - shownAtRef.current;
    const remain = Math.max(0, minShowMs - elapsed);

    hideTimerRef.current = setTimeout(() => {
      setVisible(false);

      // 페이드 아웃 시간 후 언마운트
      setTimeout(() => setMounted(false), 200);
    }, remain);

    return () => {
      clearTimeout(hideTimerRef.current);
    };
  }, [active, delayMs, minShowMs, visible]);

  if (!mounted) return null;

  return (
    <div className={`loading-overlay ${visible ? "is-visible" : ""}`}>
      <div className="loading-box">
        <div className="loading-spinner" />
        <div className="loading-text">{text}</div>
      </div>
    </div>
  );
}